export const FILTER_FILTERSTATUSES = 'filterStatuses';

export const FILTER_PARTNERS = 'partners';
export const FILTER_COUNTRIES = 'countries';
export const FILTER_APPLICATIONS = 'applications';
export const FILTER_ACCOUNTS = 'accounts';
export const FILTER_CREATED_BY = 'createdBy';

export const FILTERS_DEPENDENCIES = {
  [FILTER_ACCOUNTS]: [FILTER_PARTNERS],
};

export const COLUMN_ID = 'id';
export const COLUMN_NAME = 'name';
export const COLUMN_STATUS = 'filterStatus';
export const COLUMN_PARENT = 'parent';
export const COLUMN_PARTNER = 'partner';
export const COLUMN_PARTNER_API_ID = 'partnerApiId';
export const COLUMN_COUNTRIES = 'countries';
export const COLUMN_APPROXIMATE_USERS = 'approximateUsers';
export const COLUMN_LAST_SYNC = 'lastSyncDate';
export const COLUMN_ACCOUNT = 'account';
export const COLUMN_CREATED_BY = 'createdBy';
export const COLUMN_CREATED_DATE = 'createdDate';

export const ACTION_SHARE = 'share';
export const ACTION_DELETE = 'delete';
